import { render } from "./IndexBanner.vue?vue&type=template&id=8a7543a0&scoped=true"
import script from "./IndexBanner.vue?vue&type=script&lang=js"
export * from "./IndexBanner.vue?vue&type=script&lang=js"

import "./IndexBanner.vue?vue&type=style&index=0&id=8a7543a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7543a0"]])

export default __exports__